import style from "./form.module.scss";

function TextArea({label, allowEntry, valueState}) {
    return (
        <div className={style.input_cnt}>
            <label>{label}</label>
            <textarea className="cleartext" value={valueState.value} onChange={(e)=>valueState.setValue(e.target.value)} disabled={!allowEntry} required/>
        </div>
    )
}

export default TextArea;